import React, { useContext, useEffect, useState } from "react";
import UserAvatar from "../../component/global/UserAvatar";
import { Image } from "react-bootstrap";
import { GlobalStateContext } from "../GlobalStates";
import { Link } from "react-router-dom";
import userEditIcon from "../../asset/icons/userEditIcon.svg";
import { get } from "../../controlers/global/ConfigRequest";
import { COMPANY_DETAIL, COMPANY_LIST_URL } from "../../helperData/ApiAddress";

const RightSidebarUserInfo = () => {
    const { auth } = useContext(GlobalStateContext);
    const [companyName, setCompanyName] = useState("");

    useEffect(() => {
        if (!auth.access_token) {
            setCompanyName("");
            return;
        }

        let cancelled = false;
        const applyName = (name) => {
            if (!cancelled) setCompanyName(name || "");
        };

        if (auth.usercompany) {
            get(COMPANY_DETAIL.replace("{id}", auth.usercompany))
                .then((r) => applyName(r?.name))
                .catch(() => applyName(""));
        } else {
            get(COMPANY_LIST_URL)
                .then((r) => applyName(r?.results?.[0]?.name))
                .catch(() => applyName(""));
        }

        return () => {
            cancelled = true;
        };
    }, [auth.access_token, auth.usercompany]);

    // const login = () => {
    //   let username = prompt("Username:");
    //   let password = prompt("Password:");
    //   let data = {
    //     client_id: "RoYRoxQu7FzkoEaT5h9PSGUMJXetJNZdBx8WQCcN",
    //     grant_type: "password",
    //     username,
    //     password,
    //   };
    //   axios({
    //     method: "POST",
    //     url: LOGIN_ADDRESS,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: data,
    //   })
    //     .then((response) => {
    //       Cookies.set("login_info", JSON.stringify(response.data));
    //       setAuth(response.data);
    //     })
    //     .catch((error) => {
    //       if (error.response) {
    //         // The request was made and the server responded with a status code
    //       } else if (error.request) {
    //         // The request was made but no response was received
    //       } else {
    //         // Something happened in setting up the request that triggered an Error
    //       }
    //     });
    // };

    // const logoutHandle = () => {
    //   Cookies.remove("login_info");
    //   setAuth({ access_token: "" });
    //   window.location.reload();
    // };

    return (
        <div className="user_info">
            <div className="user_info_content">
                {/* <UserAvatar onlineStatus={true} /> */}
                <div className="user_name">
                    <div className="user-name-family">
                        {auth.first_name
                            ? auth.first_name + " " + auth.last_name
                            : "کاربر میهمان"}
                    </div>
                    <div
                        className="user-name-info"
                        title={companyName || undefined}
                    >
                        {companyName || "خوش آمدید"}
                    </div>
                </div>
                {auth.access_token && (
                    <Link
                        to={
                            auth.usertype === 1 || auth.usertype === 2
                                ? "/dashboard/profile"
                                : "/dashboard/user/profile"
                        }
                    >
                        <Image
                            className="user_edit_icon"
                            src={userEditIcon}
                            alt="edit user info"
                        />
                    </Link>
                )}
            </div>
        </div>
    );
};

export default RightSidebarUserInfo;
